import { motion } from "framer-motion";
import { ScanLine, Boxes, Users, Timer, ShieldCheck, BarChart3, ClipboardCheck, Headset } from "lucide-react";
import Section, { SectionHeading } from "@/components/Section";

const CARDS = [
  { icon: ScanLine, title: "Picking Accuracy" },
  { icon: Boxes, title: "Packing Discipline" },
  { icon: Users, title: "Store Supervision" },
  { icon: Timer, title: "Attendance Control" },
  { icon: ShieldCheck, title: "Quality Checks" },
  { icon: BarChart3, title: "Daily MIS" },
  { icon: ClipboardCheck, title: "SOP Execution" },
  { icon: Headset, title: "Escalation Control" },
];

export default function DarkStoreOps() {
  return (
    <Section id="dark-store-ops" bg="white">
      <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-12 items-center">
        <div>
          <SectionHeading
            eyebrow="Dark Store Management by Manpower"
            title={<>People. Process. <span className="text-[#99CC00]">Performance.</span></>}
            sub="OneHill manages the operating layer inside dark stores — trained pickers, packers, supervisors, store managers, housekeeping, security coordination, attendance control, SOP execution, daily MIS and escalation management."
          />
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mt-8 rounded-3xl border-l-4 bg-[#F7F8F5] p-6"
            style={{ borderColor: "#99CC00" }}
          >
            <div className="text-xl lg:text-2xl font-display font-black text-[#1F1F1F]">Not headcount. A managed operations system.</div>
            <div className="mt-2 text-neutral-600">Designed for accuracy, speed, accountability and scale.</div>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              data-testid={`ops-card-${i}`}
              className="rounded-3xl border border-neutral-200 bg-white p-5 lg:p-6 shadow-sm hover:-translate-y-0.5 hover:shadow-xl hover:border-[#99CC00]/40 transition"
            >
              <div className="mb-4 inline-flex p-3 rounded-2xl" style={{ background: "rgba(153,204,0,0.14)" }}>
                <c.icon className="h-7 w-7 text-[#99CC00]" />
              </div>
              <div className="text-base lg:text-lg font-display font-black text-[#1F1F1F]">{c.title}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </Section>
  );
}
